import parsePhoneNumberFromString from 'libphonenumber-js';

export const validatePhone = (phone: string) => {
	if (
		phone &&
		phone.startsWith('7') &&
		phone.replace(/\(|\)\s/, '').length === 11 &&
		parsePhoneNumberFromString(phone, 'RU')
	) {
		return `+${phone}`;
	}

	if (phone && !phone.startsWith('+')) {
		return `+${phone}`;
	}

	return phone;
};
